import { render, staticRenderFns } from "./scssInit.vue?vue&type=template&id=512e4cba"
import script from "./scssInit.vue?vue&type=script&lang=js"
export * from "./scssInit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports